// Bridges the Auth0 React SDK's async token getter into the non-React axios
// client. The provider registers a getter on mount; the http client calls it to
// obtain a fresh access token (the SDK handles silent renewal / refresh-token
// rotation internally).
type TokenGetter = () => Promise<string | null>;

let tokenGetter: TokenGetter | null = null;
let logoutHandler: (() => void) | null = null;

export const registerTokenGetter = (getter: TokenGetter): void => {
  tokenGetter = getter;
};

// Returns a fresh token, or null when no getter is registered yet (startup
// race before AuthRoutesProvider mounts). A token-renewal failure is NOT
// swallowed here: it propagates so callers can retry rather than sending an
// unauthenticated request into the 401-logout path.
export const getAccessToken = async (): Promise<string | null> => {
  if (!tokenGetter) {
    return null;
  }
  return tokenGetter();
};

export const registerLogoutHandler = (handler: () => void): void => {
  logoutHandler = handler;
};

export const triggerLogout = (): void => {
  logoutHandler?.();
};
